import React from 'react';

/* eslint-disable max-len */
const ContentIcon = () => (
  <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path
      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SupportIcon = () => (
  <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path
      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */

const DevIcon = () => (
  <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path
      d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// AIDEV-NOTE: Inline SVG of the TCI wordmark so fill can respond to the
// --spa-logo-fill theme token (white in dark mode, TCI purple in light mode).
const TCILogo = ({ className }: { className?: string }) => (
  <svg
    aria-label="TCI"
    className={className}
    role="img"
    viewBox="0 0 120 48.4"
  >
    <polygon points="6.2,47.6 14.2,10.3 0,10.3 2,1 43.7,1 41.7,10.3 27.2,10.3 19.3,47.6" />
    <path d="M84.7,15.6H71.4c0.2-2.3-0.3-4-1.6-5c-1.3-1-3-1.6-4.6-1.5c-2.4-0.1-4.7,0.7-6.5,2.1c-1.9,1.5-3.4,3.5-4.4,5.6c-1.2,2.5-2.1,5.1-2.6,7.9c-0.3,1.1-0.5,2.3-0.6,3.5c-0.2,1.6-0.1,3.3,0.1,4.9c0.2,1.6,0.9,3.1,2.1,4.3c1.5,1.3,3.4,2,5.4,1.9c1.9,0,3.7-0.4,5.3-1.3c1.1-0.7,2.1-1.7,2.8-2.8c0.5-0.8,0.9-1.6,1.2-2.5h13.4c-0.6,3.2-2.1,6.2-4.3,8.6c-1.9,2.1-4.2,3.7-6.8,4.7c-2.3,1-4.8,1.7-7.3,2c-1.9,0.3-3.9,0.4-5.9,0.4c-1.8,0-3.6-0.1-5.4-0.4c-2.1-0.4-4.1-0.9-6-1.7c-2-0.9-3.7-2.3-5.1-4c-1.3-1.8-2.2-3.8-2.6-5.9c-0.4-2-0.6-4.1-0.4-6.2c0.1-1.9,0.4-3.7,0.7-5.5c0.7-3.3,1.8-6.4,3.3-9.4c1.6-3.1,3.8-6,6.4-8.4c2.7-2.5,5.8-4.3,9.3-5.5c3.2-1,6.5-1.4,9.9-1.4C74.9-0.1,80.1,1.8,83,5.6c0.9,1.2,1.5,2.6,1.8,4c0.2,1.1,0.3,2.3,0.2,3.5C84.9,14.2,84.8,15,84.7,15.6L84.7,15.6z" />
    <polygon points="84.6,47.6 90.7,17.4 120,11.4 120,10.3 92.6,10.3 94.5,1 107.8,1 97.9,47.6" />
    <path d="M107.3,43.2h-1.7v-0.9h4.5v0.9h-1.7v4.6h-1.2L107.3,43.2z" />
    <path d="M110.6,42.3h1.9l1.2,4l1.2-4h1.9v5.5h-1.2V43l-1.5,4.7h-1l-1.5-4.7v4.7h-1.1V42.3z" />
  </svg>
);

export { ContentIcon, DevIcon, SupportIcon, TCILogo };
